import styled from 'styled-components'
import Base from '../base'

const Text =  styled(Base.withComponent('p'))`
    ${props => props.big && `font-size:1rem;`}
    `

export default Text